export var PANELS = {
    DAYS: 'days',
    MONTHS: 'months',
    YEARS: 'years',
};
export var MONTHS_NAMES = [
    'Январь',
    'Февраль',
    'Март',
    'Апрель',
    'Май',
    'Июнь',
    'Июль',
    'Август',
    'Сентябрь',
    'Октябрь',
    'Ноябрь',
    'Декабрь',
];
export var EMPTY_DATE = '';
export var DATE_LENGTH = 8;
export var RANGE_DELIMETER = ' - ';
export var RU_FORMAT_PATTERN = /^(?<day>[0-9]{2}).(?<month>[0-9]{2}).(?<year>[0-9]{4})$/;
export var ISO_FORMAT_PATTERN = /^(?<year>[0-9]{4})-(?<month>[0-9]{2})-(?<day>[0-9]{2})$/;
export var ONE_DAY = 1;
export var DAYS_IN_WEEK = 7;
export var SUNDAY_INDEX = 0;
export var WEEKDAYS = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];
